exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-result[data-v-c7132924] {\n  text-align: center;\n  padding-top: 0.84rem;\n}\n.no-result img[data-v-c7132924] {\n  width: 1.92rem;\n  height: 1.35rem;\n}\n.no-result .text[data-v-c7132924] {\n  font-size: 0.14rem;\n  line-height: 0.26rem;\n  color: #84849a;\n  padding-top: 0.45rem;\n}\n", ""]);

// exports
